module.exports = __webpack_public_path__ + "img/nav-spain-cover.98710a1d.jpg";